import React from 'react';
import {
  WebsitesIcon,
  OperatorsIcon,
  ConversationsIcon,
  BlacklistIcon,
  ReportsIcon,
  WhatsappIcon,
  UrlIcon,
  SendIcon,
  SettingsIcon,
  webhookIcon,
} from '../../assets/icons';
import MainMenuItem from './MainMenuItem';
import routes from '../../routes';

const items = [
  {
    url: routes.websites,
    tooltip: 'لیست وب‌سایت ها',
    iconUrl: WebsitesIcon,
    iconAlt: 'لیست وب‌سایت ها',
    accessLevels: ['admin'],
  },
  {
    url: routes.operators,
    tooltip: 'اپراتورها',
    iconUrl: OperatorsIcon,
    iconAlt: 'اپراتورها',
    accessLevels: ['admin'],
  },
  {
    url: routes.widgetInstallation,
    tooltip: 'نصب و راه اندازی',
    iconUrl: SettingsIcon,
    iconAlt: '',
    accessLevels: ['admin'],
  },
  {
    url: routes.conversations,
    tooltip: 'پنل گفتگوی آنلاین',
    iconUrl: ConversationsIcon,
    iconAlt: 'مکالمه‌ها',
    accessLevels: ['admin', 'user'],
  },
  {
    url: routes.blacklist,
    tooltip: 'لیست سیاه',
    iconUrl: BlacklistIcon,
    iconAlt: 'لیست بلوکه ها',
    accessLevels: ['admin'],
  },
  {
    url: routes.conversationsReport,
    tooltip: 'آمار',
    iconUrl: ReportsIcon,
    iconAlt: '',
    accessLevels: ['admin'],
  },
  {
    url: routes.connectWhatsapp,
    tooltip: 'اتصال واتساپ',
    iconUrl: WhatsappIcon,
    iconAlt: '',
    accessLevels: ['admin'],
  },
  {
    url: routes.settingsTeam,
    tooltip: 'تنظیمات تیم',
    iconUrl: UrlIcon,
    iconAlt: '',
    accessLevels: ['admin'],
  },
  {
    url: routes.groupMessage,
    tooltip: 'پیام گروهی',
    iconUrl: SendIcon,
    iconAlt: '',
    accessLevels: ['admin'],
  },
  {
    url: routes.webhook,
    tooltip: 'وب هوک',
    iconUrl: webhookIcon,
    iconAlt: 'وب هوک',
    accessLevels: ['admin'],
  },
  // {
  //   url: routes.teams,
  //   tooltip: 'تیم ها',
  //   iconUrl: SendIcon,
  //   iconAlt: '',
  //   accessLevels: ['admin'],
  // },
];

const MainMenu = (props) => {
  return (
    <div className='primary__menu__top__icons flex flex-column'>
      {items.map((item, index) => (
        <MainMenuItem key={index} {...item} />
      ))}
    </div>
  );
};

export default MainMenu;
